import { useState } from "react"
import { Link } from "react-router-dom"
import { useLanguage } from "../i18n/LanguageContext"

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false)
    const { lang, setLang, t } = useLanguage()

    const toggleLang = () => setLang(lang === 'nl' ? 'en' : 'nl')

    return (
        <header className="header">
            <Link to="/" className="header_brand">
                <img className="header_logo" src={require("../img/logo.png")} alt={t('altLogo')} />
                <span className="header_title">Parking Haarlem</span>
            </Link>

            <nav className="header_nav">
                <Link className="header_nav_link" to="/">{t('home')}</Link>
                <Link className="header_nav_link" to="/over-ons">{t('about')}</Link>
                <button className="header_lang_toggle" onClick={toggleLang}>
                    <span className={lang === 'nl' ? 'active' : ''}>NL</span>
                    <span className={lang === 'en' ? 'active' : ''}>EN</span>
                </button>
            </nav>

            <div className="header_right_mobile">
                <button className="header_lang_toggle" onClick={toggleLang}>
                    <span className={lang === 'nl' ? 'active' : ''}>NL</span>
                    <span className={lang === 'en' ? 'active' : ''}>EN</span>
                </button>
                <button
                    className="header_hamburger"
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Menu openen"
                >
                    <span className={`header_hamburger_bar ${menuOpen ? 'open' : ''}`}></span>
                    <span className={`header_hamburger_bar ${menuOpen ? 'open' : ''}`}></span>
                    <span className={`header_hamburger_bar ${menuOpen ? 'open' : ''}`}></span>
                </button>
            </div>

            <div className={`header_mobile_overlay ${menuOpen ? 'active' : ''}`}>
                <nav className="header_mobile_nav">
                    <Link className="header_mobile_link" to="/" onClick={() => setMenuOpen(false)}>{t('home')}</Link>
                    <Link className="header_mobile_link" to="/over-ons" onClick={() => setMenuOpen(false)}>{t('about')}</Link>
                </nav>
            </div>
        </header>
    )
}

export default Header
